// removed by extract-text-webpack-plugin
module.exports = {"component":"YoKNHAqFlgso5dHk33cia","header":"_10-T9XNTtobkOQc6_03sKA","message":"_1vUt5ctr7PpqC2ynnp1KQt","subheading":"_19dGv7YHgCBkAMoR4c7Gg","list":"_26WsAgQn4fnK_KoD6UEm7I","notification":"_1y7m9vcGT5--eo0jI1MkXm","truncate":"J4WybA-PeLSb1yUJ2-L5P","details":"_37LQFQQLAehUKsMwlunl20","action":"oL6cgATwwB5MwUWQXxfaQ","caret":"_3DJ5AFm65pC5suzP3GG5Vt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Notifications/Notifications.css
// module id = 479
// module chunks = 0